function getShopLanguage() {
  const documentLanguage =
    document.documentElement.lang || '';

  const shopifyLanguage =
    window.Shopify && window.Shopify.locale
      ? window.Shopify.locale
      : '';

  const themeLanguage =
    window.shopLocale || '';

  const language =
    documentLanguage ||
    shopifyLanguage ||
    themeLanguage ||
    'de';

  return language.toLowerCase().split('-')[0];
}

const ratingTranslations = {
  de: {
    'Über 1200 glückliche Kunden': 'Über 1200 glückliche Kunden',
    'Over 1200 happy customers': 'Über 1200 glückliche Kunden',
    'Over 1,200 happy customers': 'Über 1200 glückliche Kunden',
    'Plus de 1200 clients satisfaits': 'Über 1200 glückliche Kunden',
    'Plus de 1 200 clients satisfaits': 'Über 1200 glückliche Kunden',
    'Oltre 1200 clienti soddisfatti': 'Über 1200 glückliche Kunden',
    'Oltre 1.200 clienti soddisfatti': 'Über 1200 glückliche Kunden'
  },

  en: {
    'Über 1200 glückliche Kunden': 'Over 1,200 happy customers',
    'Over 1200 happy customers': 'Over 1,200 happy customers',
    'Over 1,200 happy customers': 'Over 1,200 happy customers',
    'Plus de 1200 clients satisfaits': 'Over 1,200 happy customers',
    'Plus de 1 200 clients satisfaits': 'Over 1,200 happy customers',
    'Oltre 1200 clienti soddisfatti': 'Over 1,200 happy customers',
    'Oltre 1.200 clienti soddisfatti': 'Over 1,200 happy customers'
  },

  fr: {
    'Über 1200 glückliche Kunden': 'Plus de 1 200 clients satisfaits',
    'Over 1200 happy customers': 'Plus de 1 200 clients satisfaits',
    'Over 1,200 happy customers': 'Plus de 1 200 clients satisfaits',
    'Plus de 1200 clients satisfaits': 'Plus de 1 200 clients satisfaits',
    'Plus de 1 200 clients satisfaits': 'Plus de 1 200 clients satisfaits',
    'Oltre 1200 clienti soddisfatti': 'Plus de 1 200 clients satisfaits',
    'Oltre 1.200 clienti soddisfatti': 'Plus de 1 200 clients satisfaits'
  },

  it: {
    'Über 1200 glückliche Kunden': 'Oltre 1.200 clienti soddisfatti',
    'Over 1200 happy customers': 'Oltre 1.200 clienti soddisfatti',
    'Over 1,200 happy customers': 'Oltre 1.200 clienti soddisfatti',
    'Plus de 1200 clients satisfaits': 'Oltre 1.200 clienti soddisfatti',
    'Plus de 1 200 clients satisfaits': 'Oltre 1.200 clienti soddisfatti',
    'Oltre 1200 clienti soddisfatti': 'Oltre 1.200 clienti soddisfatti',
    'Oltre 1.200 clienti soddisfatti': 'Oltre 1.200 clienti soddisfatti'
  }
};

const bundleTitleTranslations = {
  de: {
    'Wähle dein perfektes Set': 'Wähle dein perfektes Set',
    'Wähle dein perfecktes Set': 'Wähle dein perfektes Set',
    'Choose your perfect set': 'Wähle dein perfektes Set',
    'Choisissez votre set idéal': 'Wähle dein perfektes Set',
    'Scegli il set perfetto per te': 'Wähle dein perfektes Set'
  },

  en: {
    'Wähle dein perfektes Set': 'Choose your perfect set',
    'Wähle dein perfecktes Set': 'Choose your perfect set',
    'Choose your perfect set': 'Choose your perfect set',
    'Choisissez votre set idéal': 'Choose your perfect set',
    'Scegli il set perfetto per te': 'Choose your perfect set'
  },

  fr: {
    'Wähle dein perfektes Set': 'Choisissez votre set idéal',
    'Wähle dein perfecktes Set': 'Choisissez votre set idéal',
    'Choose your perfect set': 'Choisissez votre set idéal',
    'Choisissez votre set idéal': 'Choisissez votre set idéal',
    'Scegli il set perfetto per te': 'Choisissez votre set idéal'
  },

  it: {
    'Wähle dein perfektes Set': 'Scegli il set perfetto per te',
    'Wähle dein perfecktes Set': 'Scegli il set perfetto per te',
    'Choose your perfect set': 'Scegli il set perfetto per te',
    'Choisissez votre set idéal': 'Scegli il set perfetto per te',
    'Scegli il set perfetto per te': 'Scegli il set perfetto per te'
  }
};

const trustBadgeTranslations = {
  de: {
    'Kostenloser Versand': 'Kostenloser Versand',
    'Free shipping': 'Kostenloser Versand',
    'Livraison gratuite': 'Kostenloser Versand',
    'Spedizione gratuita': 'Kostenloser Versand',

    '60 Tage sorgenfrei testen': '60 Tage sorgenfrei testen',
    '60-day worry-free trial': '60 Tage sorgenfrei testen',
    'Testez sans souci pendant 60 jours':
      '60 Tage sorgenfrei testen',
    'Prova senza preoccupazioni per 60 giorni':
      '60 Tage sorgenfrei testen',

    'Heute bis 16:00 Uhr bestellt – schon ab morgen bei dir':
      'Heute bis 16:00 Uhr bestellt – schon ab morgen bei dir',
    'Order by 4:00 PM today, delivered as early as tomorrow':
      'Heute bis 16:00 Uhr bestellt – schon ab morgen bei dir',
    'Commandé aujourd’hui avant 16 h, livré dès demain':
      'Heute bis 16:00 Uhr bestellt – schon ab morgen bei dir',
    'Ordina oggi entro le 16:00, consegna già da domani':
      'Heute bis 16:00 Uhr bestellt – schon ab morgen bei dir'
  },

  en: {
    'Kostenloser Versand': 'Free shipping',
    'Free shipping': 'Free shipping',
    'Livraison gratuite': 'Free shipping',
    'Spedizione gratuita': 'Free shipping',

    '60 Tage sorgenfrei testen': '60-day worry-free trial',
    '60-day worry-free trial': '60-day worry-free trial',
    'Testez sans souci pendant 60 jours':
      '60-day worry-free trial',
    'Prova senza preoccupazioni per 60 giorni':
      '60-day worry-free trial',

    'Heute bis 16:00 Uhr bestellt – schon ab morgen bei dir':
      'Order by 4:00 PM today, delivered as early as tomorrow',
    'Order by 4:00 PM today, delivered as early as tomorrow':
      'Order by 4:00 PM today, delivered as early as tomorrow',
    'Commandé aujourd’hui avant 16 h, livré dès demain':
      'Order by 4:00 PM today, delivered as early as tomorrow',
    'Ordina oggi entro le 16:00, consegna già da domani':
      'Order by 4:00 PM today, delivered as early as tomorrow'
  },

  fr: {
    'Kostenloser Versand': 'Livraison gratuite',
    'Free shipping': 'Livraison gratuite',
    'Livraison gratuite': 'Livraison gratuite',
    'Spedizione gratuita': 'Livraison gratuite',

    '60 Tage sorgenfrei testen':
      'Testez sans souci pendant 60 jours',
    '60-day worry-free trial':
      'Testez sans souci pendant 60 jours',
    'Testez sans souci pendant 60 jours':
      'Testez sans souci pendant 60 jours',
    'Prova senza preoccupazioni per 60 giorni':
      'Testez sans souci pendant 60 jours',

    'Heute bis 16:00 Uhr bestellt – schon ab morgen bei dir':
      'Commandé aujourd’hui avant 16 h, livré dès demain',
    'Order by 4:00 PM today, delivered as early as tomorrow':
      'Commandé aujourd’hui avant 16 h, livré dès demain',
    'Commandé aujourd’hui avant 16 h, livré dès demain':
      'Commandé aujourd’hui avant 16 h, livré dès demain',
    'Ordina oggi entro le 16:00, consegna già da domani':
      'Commandé aujourd’hui avant 16 h, livré dès demain'
  },

  it: {
    'Kostenloser Versand': 'Spedizione gratuita',
    'Free shipping': 'Spedizione gratuita',
    'Livraison gratuite': 'Spedizione gratuita',
    'Spedizione gratuita': 'Spedizione gratuita',

    '60 Tage sorgenfrei testen':
      'Prova senza preoccupazioni per 60 giorni',
    '60-day worry-free trial':
      'Prova senza preoccupazioni per 60 giorni',
    'Testez sans souci pendant 60 jours':
      'Prova senza preoccupazioni per 60 giorni',
    'Prova senza preoccupazioni per 60 giorni':
      'Prova senza preoccupazioni per 60 giorni',

    'Heute bis 16:00 Uhr bestellt – schon ab morgen bei dir':
      'Ordina oggi entro le 16:00, consegna già da domani',
    'Order by 4:00 PM today, delivered as early as tomorrow':
      'Ordina oggi entro le 16:00, consegna già da domani',
    'Commandé aujourd’hui avant 16 h, livré dès demain':
      'Ordina oggi entro le 16:00, consegna già da domani',
    'Ordina oggi entro le 16:00, consegna già da domani':
      'Ordina oggi entro le 16:00, consegna già da domani'
  }
};

function replaceTextInElement(element, translations) {
  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT
  );

  const textNodes = [];

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach(node => {
    let text = node.nodeValue;

    Object.entries(translations).forEach(
      ([original, translated]) => {
        if (text.includes(original)) {
          text = text.replaceAll(
            original,
            translated
          );
        }
      }
    );

    node.nodeValue = text;
  });
}

function translateWidgets() {
  const language = getShopLanguage();

  const bundlerStrings =
    window.bundlerStrings || {};

  const translations = {
    ...bundlerStrings,

    ...(ratingTranslations[language] ||
      ratingTranslations.de),

    ...(bundleTitleTranslations[language] ||
      bundleTitleTranslations.de),

    ...(trustBadgeTranslations[language] ||
      trustBadgeTranslations.de)
  };

  const elements = document.querySelectorAll(
    '#ss-trust-badges, ' +
    '.product-info__buy-buttons, ' +
    '.product-info__rating, ' +
    '[class*="bundler"], ' +
    '[class*="Bundler"], ' +
    '[class*="jdgm"], ' +
    '[class*="judge"], ' +
    '[class*="Judge"]'
  );

  elements.forEach(element => {
    replaceTextInElement(
      element,
      translations
    );
  });
}


/* =========================================================
   CCLINQ – MITTLERES BUNDLE NUR EINMAL AUTOMATISCH AUSWÄHLEN
   ========================================================= */

let cclinqMiddleDefaultApplied = false;

function selectMiddleBundleAsDefault() {
  if (cclinqMiddleDefaultApplied) {
    return;
  }

  const middleOption = document.querySelector(
    '.bndlr-automatic-volume-bundle ' +
    '.bndlr-radio-container[data-discount-index="1"] ' +
    'input[type="radio"]'
  );

  if (!middleOption) {
    return;
  }

  cclinqMiddleDefaultApplied = true;

  if (!middleOption.checked) {
    middleOption.click();
  }
}


/* =========================================================
   WIDGETS STARTEN
   ========================================================= */

function startWidgetTranslations() {
  function applyTranslationsAndDefaultBundle() {
    translateWidgets();
    selectMiddleBundleAsDefault();
  }

  applyTranslationsAndDefaultBundle();

  const observer = new MutationObserver(() => {
    applyTranslationsAndDefaultBundle();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    startWidgetTranslations
  );
} else {
  startWidgetTranslations();
}